<template>
    
        <v-container class="">
            <v-row class="">
                

<html>
	<head>
		<meta content="text/html; charset=UTF-8" http-equiv="content-type">
			
		</head>
		<body class="c15 px-4">
			<p class="c7">
				<span class="c11 c21">Data Privacy</span>
			</p>
			<p class="c7">
				<span class="c1">Zasnova Healthcare Private Limited (&ldquo;We&rdquo; or &ldquo;Us&rdquo;, as the context may be) are committed to protecting and respecting your privacy.
					<br>This policy (together with our terms of use and any other documents referred to on it) (&ldquo;Privacy Policy&rdquo;) sets out the basis on which any personal data we collect from you, or that you provide to us, will be processed by us. The purpose of this policy is to give you confidence as you visit and use the www.healthyalways.com and/or our app (&ldquo;Site&rdquo;), and to demonstrate our commitment to fair information practices and the protection of privacy. This policy is only applicable to this Site.
						<br>Please read the following carefully to understand our views and practices regarding your personal data and how we will treat it. By using the Site you are accepting and consenting to the practices described in this Privacy Policy. If you do not understand any aspect of our Privacy Policy, please feel free to contact us using the information found at the end of the Privacy Policy.
						</span>
					</p>
					<p class="c7 c8">
						<span class="c1"></span>
					</p>
					<p class="c7">
						<span class="c6">For the purpose of the Data Protection, the data controller is Zasnova Healthcare Private Limited.</span>
					</p>
					<ul class="c14 lst-kix_list_9-0 start">
						<li class="c5">
							<span class="c1">Section 43A of the Information Technology Act, 2000;</span>
						</li>
						<li class="c5">
							<span class="c1">Regulation 4 of the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Information) Rules, 2011 (the &ldquo;SPI Rules&rdquo;);</span>
						</li>
						<li class="c7 c13">
							<span class="c1">Regulation 3(1) of the Information Technology (Intermediaries Guidelines) Rules, 2011.</span>
						</li>
					</ul>
					<p class="c7 c8">
						<span class="c1"></span>
					</p>
					<p class="c7">
						<span class="c6">Under 18 Years of Age</span>
					</p>
					<p class="c7">
						<span class="c1">Our Site is not eligible for use by persons under 18 years of age without legal parental or guardian consent. No one under age 18 may provide any personal information to or on our Site without legal parental or guardian consent. We do not knowingly collect personal information from persons under 18 if such information is provided without legal parental or guardian consent. If you are under 18, do not use or provide any information about yourself to us, including your name, address, telephone number, e-mail address or any screen name or user name you may use without legal parental or guardian consent. If we learn we have collected or received personal information from a person under 18 without verification of parental consent, we will delete that information. If you believe we might have any information from or about a person under 18 for which there is no legal parental or guardian consent, please contact us.</span>
					</p>
					<p class="c7 c8">
						<span class="c1"></span>
					</p>
					<p class="c7">
						<span class="c11">Information we collect from you</span>
						<span class="c1">
							<br>We will collect and process the following data about you:
								<br>Information you give us. This is information about you that you give us by filling in forms on our the Site or by corresponding with us by phone, e-mail or otherwise. It includes information you provide when you register to use our Site, subscribe to our Services, carry out an appointment with a Platform Doctor and when you report a problem with our Site.
								</span>
							</p>
							<ul class="c14 lst-kix_list_1-0 start">
								<li class="c5">
									<span class="c1">Identity Data includes first name, last name, address, username or similar identifier, marital status, title, date of birth and gender. In certain circumstances, it may also include your Passport number and/or copy, Insurance ID number and/or copy, Nationality, place of work and work ID number.</span>
								</li>
								<li class="c5">
									<span class="c1">Contact Data includes billing address, delivery address, location, email address and/or telephone numbers.</span>
								</li>
								<li class="c5">
									<span class="c1">Photos or other data uploaded onto our Site by you</span>
								</li>
								<li class="c5">
									<span class="c1">Communications with us via social media platforms, email, electronic messages and other electronic and non-electronic communications;</span>
								</li>
								<li class="c5">
									<span class="c1">Your networks and connections made available to us, depending on the permissions you have granted, from your mobile and desktop devices&rsquo; address book contacts, and other social media such as Facebook, Instagram, and Twitter.</span>
								</li>
								<li class="c5">
									<span class="c1">Financial Data includes bank account and payment card details, payment history.</span>
								</li>
								<li class="c7 c13">
									<span class="c1">Sensitive medical data (which may include your medical history, health status and testing results, and any other non-public health information).</span>
								</li>
							</ul>
							<p class="c7">
								<span class="c1">Marketing and Communications Data includes your preferences in receiving marketing from us and our third parties and your communication preferences
									<br>Information we collect about you. With regard to each of your visits to our Site, we may collect the following information provided by you or your employer or insurer:
									</span>
								</p>
								<p class="c7">
									<span class="c6">Information may include all or some of:</span>
								</p>
								<ul class="c14 lst-kix_list_3-0 start">
									<li class="c5">
										<span class="c1">Mobile number</span>
									</li>
								</ul>
								<ul class="c14 lst-kix_list_2-0 start">
									<li class="c5">
										<span class="c1">Email address (personal or corporate)</span>
									</li>
									<li class="c5">
										<span class="c1">Employee ID</span>
									</li>
									<li class="c5">
										<span class="c1">Insurance Category</span>
									</li>
									<li class="c5">
										<span class="c1">Insurance Coverage and other policy related details</span>
									</li>
									<li class="c5">
										<span class="c1">Marital Status</span>
									</li>
									<li class="c5">
										<span class="c1">Place and Department of Employment</span>
									</li>
									<li class="c5">
										<span class="c1">Employment Status</span>
									</li>
									<li class="c5">
										<span class="c1">Date of Birth</span>
									</li>
									<li class="c5">
										<span class="c1">Passport Number</span>
									</li>
									<li class="c5">
										<span class="c1">Details of family members (if included in policy)</span>
									</li>
									<li class="c5">
										<span class="c1">Nationality</span>
									</li>
									<li class="c5">
										<span class="c1">Country, City, and Area of Residence</span>
									</li>
									<li class="c5">
										<span class="c1">Visa status</span>
									</li>
									<li class="c5">
										<span class="c1">Health information about you prepared by the Platform Doctors who provide the Services through the Site such as medical records, treatment notes, and other health information;</span>
									</li>
									<li class="c5">
										<span class="c1">Transaction Data includes details about payments to and from you and other details of products and services you have purchased from us.</span>
									</li>
									<li class="c5">
										<span class="c1">Technical Data includes internet protocol (IP) address, your login data, browser type and version, make and model (mobile phones only), operating system, hardware version, platform, device settings and other technology identification on the devices used to access our Sites, file and software names and types, device identifiers, time zone setting and location, device locations such as through GPS, Bluetooth or Wi-Fi signals, browser plug-in types and versions, operating system and platform, connection information such as the name of your mobile operator or ISP, browser type, language and time zone, mobile phone number and IP address.</span>
									</li>
									<li class="c5">
										<span class="c1">Profile Data includes your username and password, purchases or orders made by you, your interests, preferences, feedback and survey responses.</span>
									</li>
									<li class="c5">
										<span class="c1">Usage Data includes information about how you use our Sites, how you use your devices to access our Sites, including the screens you visit.</span>
									</li>
									<li class="c5">
										<span class="c1">Information we receive from other sources. This is information we receive about you if you use any of the other websites we operate or from third parties (including any third query party links to our Site). In this case we will have informed you when we collected that data if we intend to share those data internally and combine it with data collected on our Site. We will also have told you for what purpose we will share and combine your data;</span>
									</li>
									<li class="c5">
										<span class="c1">Information obtained from video consultation. You consent and authorize us to audio record, video record, and/or still photograph your consultation.</span>
									</li>
									<li class="c7 c13">
										<span class="c1">Aggregated data. We also collect, use and share aggregated data such as statistical or demographic data for any purpose. Aggregated Data may be derived from your personal data but is not considered personal data in law as this data does not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific Site feature. However, if we combine or connect aggregated data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this Privacy Policy.</span>
									</li>
								</ul>
								<p class="c7">
									<span>&nbsp;</span>
									<span class="c11">How is your data collected?</span>
								</p>
								<p class="c7">
									<span class="c1">We use different methods to collect data from and about you including through:</span>
								</p>
								<ul class="c14 lst-kix_list_4-0 start">
									<li class="c5">
										<span class="c1">Direct interactions. You may give us your Identity Data, Contact Data, Transaction Data, Profile Data, Financial Data, Health Information and Marketing and Communications Data by using our Site filling in forms or by corresponding with us by phone, email, in person or otherwise. This includes personal data you provide when you</span>
									</li>
									<li class="c5">
										<span class="c1">purchase a Service</span>
									</li>
									<li class="c5">
										<span class="c1">use the Service with a Platform Doctor</span>
									</li>
									<li class="c5">
										<span class="c1">create an account on our Site</span>
									</li>
									<li class="c5">
										<span class="c1">request marketing to be sent to you;</span>
									</li>
									<li class="c5">
										<span class="c1">enter a competition;</span>
									</li>
									<li class="c5">
										<span class="c1">give us feedback or contact the support team</span>
									</li>
									<li class="c5">
										<span class="c1">Automated technologies or interactions. As you interact with our website, we may automatically collect Usage Data and Technical Data about your equipment, browsing actions and patterns. We collect this personal data by using cookies, server logs and other similar technologies.</span>
									</li>
									<li class="c5">
										<span class="c1">Data provided by your Employer</span>
									</li>
									<li class="c7 c13">
										<span class="c1">Data provided by your Insurer</span>
									</li>
								</ul>
								<p class="c7">
									<span class="c6">Cookies</span>
								</p>
								<p class="c7">
									<span class="c1">Cookies are small computer files that are transferred to your computer&rsquo;s hard drive that contain information such as user ID, user preferences, lists of pages visited and activities conducted while browsing the Site. At your option, expense and responsibility, you may block cookies or delete cookies from your hard drive. However, by disabling cookies, you may not have access to the entire set of features of this Site. Our Site uses cookies to distinguish you from other users. This helps us to provide you with a good experience when you browse our Site and also allows us to improve our services.</span>
								</p>
								<p class="c7">
									<span class="c6">Location Information</span>
								</p>
								<p class="c7">
									<span class="c1">You can choose whether or not to allow our Sites to collect and use real-time information about your device&rsquo;s location through the device&rsquo;s privacy settings. If you block the use of location information, some parts of our Sites may then be inaccessible or not function properly.</span>
								</p>
								<p class="c7">
									<span class="c6">Change of Purpose</span>
								</p>
								<p class="c7">
									<span class="c1">We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to get an explanation as to how the processing for the new purpose is compatible with the original purpose, please contact us.
										<br>If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal basis which allows us to do so.
											<br>Please note that we may process your personal data without your knowledge or consent, in compliance with the above rules, where this is required or permitted by law.
											</span>
										</p>
										<p class="c7">
											<span class="c6">Links to Third Party Sites</span>
										</p>
										<p class="c7">
											<span class="c1">Our site may, from time to time, contain links to and from the websites of our partner networks, advertisers and affiliates. &nbsp;If you follow a link to any of these websites, please note that these websites have their own privacy policies and that we do not accept any responsibility or liability for these policies. &nbsp;Please check these policies before you submit any personal data to these websites.</span>
										</p>
										<p class="c7 c8">
											<span class="c1"></span>
										</p>
										<p class="c7 c8">
											<span class="c1"></span>
										</p>
										<p class="c7">
											<span class="c6">How we use your personal data</span>
										</p>
										<p class="c7">
											<span class="c1">We will only use your personal data when the law allows us to. We use information held about you in the following ways:</span>
										</p>
										<ul class="c14 lst-kix_list_5-0 start">
											<li class="c5">
												<span class="c1">to carry out our obligations to you and to provide you with the information, and medical or other services that you request from us including treatment, payment and health care operations:</span>
											</li>
											<li class="c5">
												<span class="c1">We keep a record of the health information you provide us including test results, diagnoses, medications etc. which we may disclose to laboratories, doctors, pharmacies, or other healthcare providers involved in your care;</span>
											</li>
											<li class="c5">
												<span class="c1">We keep a record of the services and supplies you receive when we are providing care to you so that this information can be used for billing purposes. This information may be provided to your insurance company if the service is being reimbursed by them;</span>
											</li>
											<li class="c5">
												<span class="c1">We may use your health information to review our services and to evaluate the performance of the Platform Doctors carrying out the Services;</span>
											</li>
											<li class="c5">
												<span class="c1">We may be required to provide your personal data to regulators as necessary</span>
											</li>
											<li class="c5">
												<span class="c1">We will pass on your personal data to a court of law when a court order has been issued</span>
											</li>
											<li class="c5">
												<span class="c1">to provide you with information about other services we offer that are similar to those that you have already purchased or enquired about;</span>
											</li>
											<li class="c5">
												<span class="c1">to provide you, or permit selected third parties to provide you, with information about goods or services we feel may interest you. If you are an existing customer, we will only contact you by electronic means (e-mail, SMS or push message ) with information about goods and services similar to those which were the subject of a previous sale or negotiations of a sale to you. If you are a new user, and where we permit selected third parties to use your data, we (or they) will contact you by electronic means only if you have consented to this.</span>
											</li>
											<li class="c5">
												<span class="c1">to notify you about changes to our Service;</span>
											</li>
											<li class="c5">
												<span class="c1">to ensure that content from our Site is presented in the most effective manner for you and for your computer.</span>
											</li>
											<li class="c5">
												<span class="c1">to administer our Site for internal operations, including troubleshooting, data analysis, testing, research, statistical and survey purposes;</span>
											</li>
											<li class="c5">
												<span class="c1">to improve our Site to ensure that content is presented in the most effective manner for you and for your computer;</span>
											</li>
											<li class="c5">
												<span class="c1">to allow you to participate in interactive features of our Service, when you choose to do so;</span>
											</li>
											<li class="c5">
												<span class="c1">as part of our efforts to keep our Site safe and secure;</span>
											</li>
											<li class="c5">
												<span class="c1">to measure or understand the effectiveness of advertising we serve to you and others, and to deliver relevant advertising to you;</span>
											</li>
											<li class="c5">
												<span class="c1">to make suggestions and recommendations to you and other users of our Site about goods or services that may interest you or them.</span>
											</li>
											<li class="c5">
												<span class="c1">to comply with a legal or regulatory obligation.</span>
											</li>
										</ul>
										<p class="c7 c8 c18">
											<span class="c1"></span>
										</p>
										<p class="c7 c8">
											<span class="c1"></span>
										</p>
										<p class="c7 c8">
											<span class="c1"></span>
										</p>
										<p class="c7 c8">
											<span class="c1"></span>
										</p>
										<p class="c7 c8">
											<span class="c1"></span>
										</p>
										<p class="c7">
											<span class="c11">Purposes for which we will use your data</span>
											<span class="c1">
												<br>We have set out below, in a table format, a description of all the ways we may use your personal data, and which of the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate.
												</span>
											</p>
											<a id="t.26a147298eaaf6300000448aa4261339a154473d"></a>
											<a id="t.0"></a>
											<table class="c16">
												<tbody>
													<tr class="c2">
														<td class="c12" colspan="1" rowspan="1">
															<p class="c0">
																<span class="c4">Purpose/Activity</span>
															</p>
														</td>
														<td class="c10" colspan="1" rowspan="1">
															<p class="c0">
																<span class="c4">Type of data</span>
															</p>
														</td>
														<td class="c9" colspan="1" rowspan="1">
															<p class="c0">
																<span class="c4">Lawful basis for processing including basis of legitimate interest</span>
															</p>
														</td>
													</tr>
													<tr class="c2">
														<td class="c12" colspan="1" rowspan="1">
															<p class="c0">
																<span class="c3">To register you as a new customer/user</span>
															</p>
														</td>
														<td class="c10" colspan="1" rowspan="1">
															<p class="c0">
																<span class="c3">(a) Identity
																	<br>(b) Contact
																		<br>(c) Profile
																		</span>
																	</p>
																</td>
																<td class="c9" colspan="1" rowspan="1">
																	<p class="c0">
																		<span class="c3">(a) Fulfilment of a contract with you
																			<br>(b) Necessary to comply with a legal obligation
																			</span>
																		</p>
																	</td>
																</tr>
																<tr class="c2">
																	<td class="c12" colspan="1" rowspan="1">
																		<p class="c0">
																			<span class="c3">To process your purchase including:
																				<br>(a) Manage payments, fees and charges
																					<br>(b) Collect and recover money owed to us
																					</span>
																				</p>
																			</td>
																			<td class="c10" colspan="1" rowspan="1">
																				<p class="c0">
																					<span class="c3">(a) Identity
																						<br>(b) Contact
																							<br>(c) Financial
																								<br>(d) Transaction
																									<br>(e) Marketing and Communications
																									</span>
																								</p>
																							</td>
																							<td class="c9" colspan="1" rowspan="1">
																								<p class="c0">
																									<span class="c3">(a) Fulfilment of a contract with you
																										<br>(b) Necessary for our legitimate interests (to recover debts due to us)
																										</span>
																									</p>
																								</td>
																							</tr>
																							<tr class="c2">
																								<td class="c12" colspan="1" rowspan="1">
																									<p class="c0">
																										<span class="c3">To manage our relationship with you which will include:
																											<br>(a) Notifying you about changes to our terms or privacy policy
																												<br>(b) Asking you to leave a review or take a survey
																													<br>(c) communicate with you about our products and services and respond to you when you contact us
																														<br>(d) managing your queries through our Customer Service team &ndash; this may include recording calls to our teams.
																														</span>
																													</p>
																												</td>
																												<td class="c10" colspan="1" rowspan="1">
																													<p class="c0">
																														<span class="c3">(a) Identity
																															<br>(b) Contact
																																<br>(c) Profile
																																	<br>(d) Marketing and Communications
																																	</span>
																																</p>
																															</td>
																															<td class="c9" colspan="1" rowspan="1">
																																<p class="c0">
																																	<span class="c3">(a) Fulfilment of a contract with you
																																		<br>(b) Necessary to comply with a legal obligation
																																			<br>(c) Necessary for our legitimate interests (to keep our records updated and to study how customers use our products/services)
																																			</span>
																																		</p>
																																	</td>
																																</tr>
																																<tr class="c2">
																																	<td class="c12" colspan="1" rowspan="1">
																																		<p class="c0">
																																			<span class="c3">To enable you to partake in a prize draw, competition or complete a survey</span>
																																		</p>
																																	</td>
																																	<td class="c10" colspan="1" rowspan="1">
																																		<p class="c0">
																																			<span class="c3">(a) Identity
																																				<br>(b) Contact
																																					<br>(c) Profile
																																						<br>(d) Usage
																																							<br>(e) Marketing and Communications
																																							</span>
																																						</p>
																																					</td>
																																					<td class="c9" colspan="1" rowspan="1">
																																						<p class="c0">
																																							<span class="c3">(a) Fulfilment of a contract with you
																																								<br>(b) Necessary for our legitimate interests (to study how customers use our products/services, to develop them and grow our business)
																																								</span>
																																							</p>
																																						</td>
																																					</tr>
																																					<tr class="c2">
																																						<td class="c12" colspan="1" rowspan="1">
																																							<p class="c0">
																																								<span class="c3">To administer and protect our business and the Sites (including troubleshooting, improvement, data analysis, testing, system maintenance, security, support, reporting and hosting of data)</span>
																																							</p>
																																						</td>
																																						<td class="c10" colspan="1" rowspan="1">
																																							<p class="c0">
																																								<span class="c3">(a) Identity
																																									<br>(b) Contact
																																										<br>(c) Profile
																																											<br>(d) Usage
																																												<br>(e) Marketing and Communications
																																													<br>(f) Technical
																																													</span>
																																												</p>
																																											</td>
																																											<td class="c9" colspan="1" rowspan="1">
																																												<p class="c0">
																																													<span class="c3">Necessary for our legitimate interests (to study how customers use our products/services, to develop them, to grow our business and to inform our marketing strategy)</span>
																																												</p>
																																											</td>
																																										</tr>
																																										<tr class="c2">
																																											<td class="c12" colspan="1" rowspan="1">
																																												<p class="c0">
																																													<span class="c3">To deliver better and more personalised Site content so that you have a beneficial and valuable experience when using our Sites, products and/or services</span>
																																												</p>
																																											</td>
																																											<td class="c10" colspan="1" rowspan="1">
																																												<p class="c0">
																																													<span class="c3">(a) Identity
																																														<br>(b) Contact
																																															<br>(c) Profile
																																																<br>(d) Usage
																																																	<br>(e) Marketing and Communications
																																																		<br>(f) Technical
																																																		</span>
																																																	</p>
																																																</td>
																																																<td class="c9" colspan="1" rowspan="1">
																																																	<p class="c0">
																																																		<span class="c3">Fulfilment of a contract with you</span>
																																																	</p>
																																																</td>
																																															</tr>
																																															<tr class="c2">
																																																<td class="c12" colspan="1" rowspan="1">
																																																	<p class="c0">
																																																		<span class="c3">To enable you to utilize a feature of a product or service provided to you.</span>
																																																	</p>
																																																</td>
																																																<td class="c10" colspan="1" rowspan="1">
																																																	<p class="c0">
																																																		<span class="c3">(a) Identity
																																																			<br>(b) Contact
																																																				<br>(c) Profile
																																																					<br>(d) Health Information
																																																					</span>
																																																				</p>
																																																			</td>
																																																			<td class="c9" colspan="1" rowspan="1">
																																																				<p class="c0">
																																																					<span class="c3">Fulfilment of a contract with you</span>
																																																				</p>
																																																			</td>
																																																		</tr>
																																																		<tr class="c2">
																																																			<td class="c12" colspan="1" rowspan="1">
																																																				<p class="c0">
																																																					<span class="c3">To provide to your insurance company/ies who may contribute to the cost of the products or services you request to use</span>
																																																				</p>
																																																			</td>
																																																			<td class="c10" colspan="1" rowspan="1">
																																																				<p class="c0">
																																																					<span class="c3">(a) Identity
																																																						<br>(b) Contact
																																																						</span>
																																																					</p>
																																																					<p class="c0">
																																																						<span class="c3">(c) Financial Information</span>
																																																					</p>
																																																					<p class="c0">
																																																						<span class="c3">(d) Health Information</span>
																																																					</p>
																																																					<p class="c0">
																																																						<span class="c3">(e) Diagnosis</span>
																																																					</p>
																																																					<p class="c0">
																																																						<span class="c3">(f) Treatment advice</span>
																																																					</p>
																																																					<p class="c0">
																																																						<span class="c3">(g) Date and Time of Service</span>
																																																					</p>
																																																				</td>
																																																				<td class="c9" colspan="1" rowspan="1">
																																																					<p class="c0">
																																																						<span class="c3">Necessary to comply with a legal obligation</span>
																																																					</p>
																																																				</td>
																																																			</tr>
																																																			<tr class="c2">
																																																				<td class="c12" colspan="1" rowspan="1">
																																																					<p class="c0">
																																																						<span class="c3">To provide to your other healthcare providers such as another clinic/ healthcare service provider</span>
																																																					</p>
																																																				</td>
																																																				<td class="c10" colspan="1" rowspan="1">
																																																					<p class="c0">
																																																						<span class="c3">(a) Identity
																																																							<br>(b) Contact
																																																								<br>(c) Profile
																																																									<br>(d) Health Information
																																																									</span>
																																																								</p>
																																																							</td>
																																																							<td class="c9" colspan="1" rowspan="1">
																																																								<p class="c0">
																																																									<span class="c3">Fulfilment of a contract with you</span>
																																																								</p>
																																																							</td>
																																																						</tr>
																																																						<tr class="c2">
																																																							<td class="c12" colspan="1" rowspan="1">
																																																								<p class="c0">
																																																									<span class="c3">To use data analytics to improve our Sites, products/services, marketing, customer relationships and experiences</span>
																																																								</p>
																																																							</td>
																																																							<td class="c10" colspan="1" rowspan="1">
																																																								<p class="c0">
																																																									<span class="c3">(a) Identity
																																																										<br>(b) Technical
																																																											<br>(c) Usage
																																																												<br>(d) Transaction
																																																													<br>(e) Special Categories of Personal Data
																																																													</span>
																																																												</p>
																																																											</td>
																																																											<td class="c9" colspan="1" rowspan="1">
																																																												<p class="c0">
																																																													<span class="c3">(a) Necessary for our legitimate interests (to define types of customers for our products and services, to keep our Sites updated and relevant, to develop our business and to inform our marketing strategy)
																																																														<br>(b) Necessary to comply with a legal obligation
																																																														</span>
																																																													</p>
																																																												</td>
																																																											</tr>
																																																											<tr class="c2">
																																																												<td class="c12" colspan="1" rowspan="1">
																																																													<p class="c0">
																																																														<span class="c3">To make suggestions and recommendations to you about goods or services that may be of interest to you</span>
																																																													</p>
																																																												</td>
																																																												<td class="c10" colspan="1" rowspan="1">
																																																													<p class="c0">
																																																														<span class="c3">(a) Identity
																																																															<br>(b) Contact
																																																																<br>(c) Technical
																																																																	<br>(d) Usage
																																																																		<br>(e) Profile
																																																																		</span>
																																																																	</p>
																																																																</td>
																																																																<td class="c9" colspan="1" rowspan="1">
																																																																	<p class="c0">
																																																																		<span class="c3">Necessary for our legitimate interests (to develop our products/services and grow our business)</span>
																																																																	</p>
																																																																</td>
																																																															</tr>
																																																															<tr class="c2">
																																																																<td class="c12" colspan="1" rowspan="1">
																																																																	<p class="c0">
																																																																		<span class="c3">Any other purpose disclosed by us when you provide the personal data</span>
																																																																	</p>
																																																																</td>
																																																																<td class="c10" colspan="1" rowspan="1">
																																																																	<p class="c0">
																																																																		<span class="c3">As applicable</span>
																																																																	</p>
																																																																</td>
																																																																<td class="c9" colspan="1" rowspan="1">
																																																																	<p class="c0">
																																																																		<span class="c3">(a) Fulfilment of a contract with you
																																																																			<br>(b) Necessary to comply with a legal obligation
																																																																			</span>
																																																																		</p>
																																																																	</td>
																																																																</tr>
																																																															</tbody>
																																																														</table>
																																																														<p class="c7 c8">
																																																															<span class="c1"></span>
																																																														</p>
																																																														<p class="c7 c8">
																																																															<span class="c1"></span>
																																																														</p>
																																																														<p class="c7 c8">
																																																															<span class="c1"></span>
																																																														</p>
																																																														<p class="c7">
																																																															<span class="c6">Marketing</span>
																																																														</p>
																																																														<p class="c7">
																																																															<span class="c11">
																																																																<br>
																																																																</span>
																																																																<span>We will always give you the option to choose not to receive marketing communications from us.</span>
																																																																<span class="c11">
																																																																	<br>
																																																																	</span>
																																																																	<span>If you do not wish to have your personal data used by Us to promote our own or third parties products or services, you can opt-out by contacting us. If we have sent you a promotional e-mail, you may send us a return e-mail asking to be omitted from future e-mail distributions. This opt out does not apply to information provided to the Us as a result of a product or service purchase, product service experience or other transactions.</span>
																																																																	<span class="c11">
																																																																		<br>
																																																																		</span>
																																																																		<span>If you do not want us to use information that we collect or that you provide to us to deliver advertisements according to our advertiser&rsquo;s target-audience preferences, you can opt-out by contacting us.</span>
																																																																	</p>
																																																																	<p class="c7">
																																																																		<span class="c11">Promotions
																																																																			<br>
																																																																			</span>
																																																																			<span>We may use your Identity, Contact, Technical, Usage and Profile Data and Special Categories of Personal Data to form a view on what we think you may want or need, or what may be of interest to you. This is how we decide which products, services and offers may be relevant for you.</span>
																																																																			<span class="c11">
																																																																				<br>
																																																																				</span>
																																																																				<span>You will receive marketing communications from us if you have requested information from us or created an account or purchased services from us or if you provided us with your details when you entered a competition or registered for a promotion and, in each case, you have not opted out of receiving that marketing.</span>
																																																																			</p>
																																																																			<p class="c7">
																																																																				<span class="c11">Third-party Marketing
																																																																					<br>
																																																																					</span>
																																																																					<span>We will get your express opt-in consent before we share your personal data with any third-party company for marketing purposes. We do not control third parties&rsquo; collection or use of your information to serve interest-based advertising. However, these third parties may provide you with ways to choose not to have your information collected or used in this way.</span>
																																																																				</p>
																																																																				<p class="c7">
																																																																					<span class="c11">Marketing Opt Out
																																																																						<br>
																																																																						</span>
																																																																						<span>You can ask us or third parties to stop sending you marketing messages at any time by following the opt-out links on any marketing message sent to you or by contacting us at any time.</span>
																																																																						<span class="c11">
																																																																							<br>
																																																																							</span>
																																																																							<span>Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us as a result of a product/service purchase, warranty registration, product/service experience or other transactions.</span>
																																																																						</p>
																																																																						<p class="c7 c8">
																																																																							<span class="c1"></span>
																																																																						</p>
																																																																						<p class="c7">
																																																																							<span class="c11">Disclosure of Your information
																																																																								<br>
																																																																								</span>
																																																																								<span>You agree that we have the right to share your personal information, with the exception of your personal health records, with any member of our group, which means our subsidiaries, our ultimate holding company and its subsidiaries.</span>
																																																																								<span class="c11">
																																																																									<br>
																																																																									</span>
																																																																									<span>We may disclose your personal information to:</span>
																																																																								</p>
																																																																								<ul class="c14 lst-kix_list_6-0 start">
																																																																									<li class="c5">
																																																																										<span class="c1">contractors, health care professionals, which may include nurses and physicians, service providers, business associates, our staff and any third parties we use to support our business and to provide health care services;</span>
																																																																									</li>
																																																																									<li class="c5">
																																																																										<span class="c1">advertisers that require the data to select and serve relevant adverts to you and others;</span>
																																																																									</li>
																																																																									<li class="c5">
																																																																										<span class="c1">analytics and search engine providers that assist us in the improvement and optimisation of our Site;</span>
																																																																									</li>
																																																																									<li class="c5">
																																																																										<span class="c1">other Service providers, health plans, or their related entities for their treatment or payment activities, or health care activities;</span>
																																																																									</li>
																																																																									<li class="c5">
																																																																										<span class="c1">third parties in the event that we sell or buy any business or assets, in which case we may disclose your data to the prospective seller or buyer of such business or assets;</span>
																																																																									</li>
																																																																									<li class="c5">
																																																																										<span class="c1">third parties if HealthyAlways or substantially all of its assets are acquired by a third party, in which case personal data held by it about its customers will be one of the transferred assets;</span>
																																																																									</li>
																																																																									<li class="c5">
																																																																										<span class="c1">third parties if we are under a duty to disclose or share your personal data in order to comply with any legal obligation, regulation, subpoena, court order, legal process or government request or in order to enforce or apply our terms of use (healthyalways.com) and other agreements; or to protect the rights, property, or safety of HealthyAlways, our customers, or others.</span>
																																																																									</li>
																																																																									<li class="c5">
																																																																										<span class="c1">third parties when we believe in good faith that disclosure is necessary to protect your safety or the safety of others, to protect our rights, to investigate fraud, or to respond to a government request;</span>
																																																																									</li>
																																																																									<li class="c7 c13">
																																																																										<span class="c1">third parties to notify or assist in notifying a family member, personal representative or another person responsible for your care of your location and general condition.</span>
																																																																									</li>
																																																																								</ul>
																																																																								<p class="c7">
																																																																									<span class="c1">You further agree that we may make your patient notes (whether provided by you or created by a doctor during a HealthyAlways consultation) available to any and all other doctors and clinics on the HealthyAlways platform.</span>
																																																																								</p>
																																																																								<p class="c7 c8">
																																																																									<span class="c1"></span>
																																																																								</p>
																																																																								<p class="c7">
																																																																									<span class="c11">Where we store your personal data</span>
																																																																									<span class="c1">
																																																																										<br>We will at all times comply with the Local Regulations in our country of operations and will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy.
																																																																											<br>We store all your personal health data &ndash; including your primary care information, secondary care information, medication information and diagnostic information &ndash; on secure servers. Any payment transactions will be encrypted. Where we have given you (or where you have chosen) a password which enables you to access certain parts of our Site, you are responsible for keeping this password confidential. We ask you not to share a password with anyone.
																																																																												<br>We do not store any credit or debit card information. Payments are processed via a third party payment provider that is fully compliant with Level 1 Payment Card Industry (PCI) data security standards. Any payment transactions are encrypted using SSL technology.
																																																																													<br>Once we have received your information, we will use strict procedures, industry standard physical, technical and administrative safeguards and security features to try to prevent unauthorised access.
																																																																													</span>
																																																																												</p>
																																																																												<p class="c7">
																																																																													<span class="c11">Protection of Passwords
																																																																														<br>
																																																																														</span>
																																																																														<span>Your account is protected by your account password, and we urge you to take steps to keep your personal information safe by not disclosing your password and by logging out of your account after each use. &nbsp;It is your responsibility to control the dissemination and use of your password, and to control access to and use of your user ID and password. &nbsp;If you need to deactivate your account, promptly inform us. You agree to promptly notify us of any unauthorized use of your username, password, or any other breach of security that you become aware of.</span>
																																																																													</p>
																																																																													<p class="c7">
																																																																														<span class="c6">Data Retention</span>
																																																																													</p>
																																																																													<p class="c7">
																																																																														<span class="c1">We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements. This includes the legal directives specified by the Indian Health Authority as the medical regulator.
																																																																															<br>To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements.
																																																																																<br>In some circumstances we may anonymise your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you.
																																																																																</span>
																																																																															</p>
																																																																															<p class="c7">
																																																																																<span class="c11">Your Rights
																																																																																	<br>
																																																																																	</span>
																																																																																	<span class="c1">You have the right to make the following requests at any time:</span>
																																																																																</p>
																																																																																<ul class="c14 lst-kix_list_8-0 start">
																																																																																	<li class="c5">
																																																																																		<span class="c1">Request access to your personal data (commonly known as a &ldquo;data subject access request&rdquo;). This enables you to receive a copy of the personal data we hold about you and to check that we are lawfully processing it.</span>
																																																																																	</li>
																																																																																</ul>
																																																																																<ul class="c14 lst-kix_list_7-0 start">
																																																																																	<li class="c5">
																																																																																		<span class="c1">Request correction of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you provide to us. The correction of medical records will only be done as a time stamped addendum. Previous notes written by our doctors will never be changed or erased.</span>
																																																																																	</li>
																																																																																	<li class="c5">
																																																																																		<span class="c1">Request erasure of your personal data. This enables you to ask us to delete or remove personal data &ndash; with the exception of medical records &ndash; where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of your request.</span>
																																																																																	</li>
																																																																																	<li class="c5">
																																																																																		<span class="c1">Object to processing of your personal data where we are relying on a legitimate interest (or those of a third party) and there is something about your particular situation which makes you want to object to processing on this ground as you feel it impacts on your fundamental rights and freedoms. You also have the right to object where we are processing your personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms.</span>
																																																																																	</li>
																																																																																	<li class="c5">
																																																																																		<span class="c1">Request restriction of processing of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios: (a) if you want us to establish the data&rsquo;s accuracy; (b) where our use of the data is unlawful but you do not want us to erase it; (c) where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims; or (d) you have objected to our use of your data but we need to verify whether we have overriding legitimate grounds to use it.</span>
																																																																																	</li>
																																																																																	<li class="c5">
																																																																																		<span class="c1">Request the transfer of your personal data to you or to a third party. We will provide to you, or a third party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you.</span>
																																																																																	</li>
																																																																																	<li class="c7 c13">
																																																																																		<span class="c1">Withdraw consent at any time where we are relying on consent to process your personal data. However, this will not affect the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent, we may not be able to provide certain products or services to you. We will advise you if this is the case at the time you withdraw your consent.</span>
																																																																																	</li>
																																																																																</ul>
																																																																																<p class="c7">
																																																																																	<span>You can exercise the right at any time by contacting us at </span>
																																																																																	<span class="c19">
																																																																																		<a class="c20" href="mailto:support@healthyalways.com">care@healthyalways.com</a>
																																																																																	</span>
																																																																																	<span class="c1">
																																																																																		<br>You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances.
																																																																																			<br>You may also request that a copy of your information be provided to another person.
																																																																																				<br>We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.
																																																																																				</span>
																																																																																			</p>
																																																																																			<p class="c7 c8">
																																																																																				<span class="c1"></span>
																																																																																			</p>
																																																																																			<p class="c7 c8">
																																																																																				<span class="c1"></span>
																																																																																			</p>
																																																																																			<p class="c7">
																																																																																				<span class="c1">Changes to our Privacy Policy
																																																																																					<br>Any changes we make to our Privacy Policy in the future will be posted on this page and, where appropriate, notified to you by e-mail. Continued use of our Site following notice of such changes will indicate your acknowledgement of such changes and agreement to be bound by the terms and conditions of such changes. By using the Site, you are agreeing to our collection, use and disposal of your personal information and other data as described in this policy, both as it exists now and as it is changed from time to time. Please check back frequently to see any updates or changes to our Privacy Policy.
																																																																																					</span>
																																																																																				</p>
																																																																																				<p class="c7 c8">
																																																																																					<span class="c1"></span>
																																																																																				</p>
																																																																																				<p class="c7">
																																																																																					<span class="c1">Contact</span>
																																																																																				</p>
																																																																																				<p class="c7">
																																																																																					<span class="c1">Questions, comments and requests regarding this Privacy Policy are welcomed and should be addressed to care@healthyalways.com.</span>
																																																																																				</p>
																																																																																				<p class="c7 c8">
																																																																																					<span class="c1"></span>
																																																																																				</p>
																																																																																				<p class="c7">
																																																																																					<span class="c17">HealthyAlways</span>
																																																																																				</p>
																																																																																				<p class="c7 c8">
																																																																																					<span class="c1"></span>
																																																																																				</p>
																																																																																				<p class="c7 c8" id="h.gjdgxs">
																																																																																					<span class="c1"></span>
																																																																																				</p>
																																																																																			</body>
																																																																																		</html>
            </v-row>
        </v-container>
</template>

<script>
    export default {
        name: "RefundPolicy",
        mounted() {
            
        },
        data() {
            return {
                
            }
        },
        methods: {
           
        },
    }
</script>
<style scoped type="text/css">@import url('https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98');
ul.lst-kix_list_1-0 {
	list-style-type: none
}

.lst-kix_list_3-0>li:before {
	content: "\0025cf  "
}

ul.lst-kix_list_5-7 {
	list-style-type: none
}

ul.lst-kix_list_9-3 {
	list-style-type: none
}

ul.lst-kix_list_5-8 {
	list-style-type: none
}

ul.lst-kix_list_9-4 {
	list-style-type: none
}

.lst-kix_list_3-1>li:before {
	content: "o  "
}

.lst-kix_list_3-2>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_5-5 {
	list-style-type: none
}

ul.lst-kix_list_9-1 {
	list-style-type: none
}

ul.lst-kix_list_5-6 {
	list-style-type: none
}

ul.lst-kix_list_9-2 {
	list-style-type: none
}

.lst-kix_list_8-1>li:before {
	content: "o  "
}

ul.lst-kix_list_9-7 {
	list-style-type: none
}

ul.lst-kix_list_9-8 {
	list-style-type: none
}

.lst-kix_list_8-2>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_9-5 {
	list-style-type: none
}

ul.lst-kix_list_9-6 {
	list-style-type: none
}

ul.lst-kix_list_1-3 {
	list-style-type: none
}

.lst-kix_list_3-5>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_5-0 {
	list-style-type: none
}

ul.lst-kix_list_1-4 {
	list-style-type: none
}

ul.lst-kix_list_1-1 {
	list-style-type: none
}

.lst-kix_list_3-4>li:before {
	content: "o  "
}

ul.lst-kix_list_1-2 {
	list-style-type: none
}

ul.lst-kix_list_5-3 {
	list-style-type: none
}

ul.lst-kix_list_1-7 {
	list-style-type: none
}

.lst-kix_list_3-3>li:before {
	content: "\0025cf  "
}

ul.lst-kix_list_5-4 {
	list-style-type: none
}

ul.lst-kix_list_9-0 {
	list-style-type: none
}

ul.lst-kix_list_1-8 {
	list-style-type: none
}

ul.lst-kix_list_5-1 {
	list-style-type: none
}

.lst-kix_list_8-0>li:before {
	content: "\0025cf  "
}

ul.lst-kix_list_1-5 {
	list-style-type: none
}

ul.lst-kix_list_5-2 {
	list-style-type: none
}

ul.lst-kix_list_1-6 {
	list-style-type: none
}

.lst-kix_list_8-7>li:before {
	content: "o  "
}

.lst-kix_list_3-8>li:before {
	content: "\0025aa  "
}

.lst-kix_list_8-5>li:before {
	content: "\0025aa  "
}

.lst-kix_list_8-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_8-3>li:before {
	content: "\0025cf  "
}

.lst-kix_list_3-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_3-7>li:before {
	content: "o  "
}

.lst-kix_list_8-4>li:before {
	content: "o  "
}

.lst-kix_list_8-8>li:before {
	content: "\0025aa  "
}

.lst-kix_list_5-0>li:before {
	content: "\0025cf  "
}

.lst-kix_list_4-8>li:before {
	content: "\0025aa  "
}

.lst-kix_list_5-3>li:before {
	content: "\0025cf  "
}

.lst-kix_list_4-7>li:before {
	content: "o  "
}

.lst-kix_list_5-2>li:before {
	content: "\0025aa  "
}

.lst-kix_list_5-1>li:before {
	content: "o  "
}

ul.lst-kix_list_4-8 {
	list-style-type: none
}

.lst-kix_list_5-7>li:before {
	content: "o  "
}

ul.lst-kix_list_8-4 {
	list-style-type: none
}

ul.lst-kix_list_8-5 {
	list-style-type: none
}

ul.lst-kix_list_4-6 {
	list-style-type: none
}

.lst-kix_list_5-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_5-8>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_8-2 {
	list-style-type: none
}

ul.lst-kix_list_4-7 {
	list-style-type: none
}

ul.lst-kix_list_8-3 {
	list-style-type: none
}

ul.lst-kix_list_8-8 {
	list-style-type: none
}

ul.lst-kix_list_8-6 {
	list-style-type: none
}

ul.lst-kix_list_8-7 {
	list-style-type: none
}

ul.lst-kix_list_4-0 {
	list-style-type: none
}

ul.lst-kix_list_4-1 {
	list-style-type: none
}

.lst-kix_list_5-4>li:before {
	content: "o  "
}

ul.lst-kix_list_4-4 {
	list-style-type: none
}

.lst-kix_list_5-5>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_8-0 {
	list-style-type: none
}

ul.lst-kix_list_4-5 {
	list-style-type: none
}

ul.lst-kix_list_8-1 {
	list-style-type: none
}

ul.lst-kix_list_4-2 {
	list-style-type: none
}

ul.lst-kix_list_4-3 {
	list-style-type: none
}

.lst-kix_list_6-1>li:before {
	content: "o  "
}

.lst-kix_list_6-3>li:before {
	content: "\0025cf  "
}

.lst-kix_list_6-0>li:before {
	content: "\0025cf  "
}

.lst-kix_list_6-4>li:before {
	content: "o  "
}

.lst-kix_list_6-2>li:before {
	content: "\0025aa  "
}

.lst-kix_list_6-8>li:before {
	content: "\0025aa  "
}

.lst-kix_list_6-5>li:before {
	content: "\0025aa  "
}

.lst-kix_list_6-7>li:before {
	content: "o  "
}

.lst-kix_list_7-0>li:before {
	content: "\0025cf  "
}

.lst-kix_list_6-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_2-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_2-7>li:before {
	content: "o  "
}

.lst-kix_list_7-4>li:before {
	content: "o  "
}

.lst-kix_list_7-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_2-4>li:before {
	content: "o  "
}

.lst-kix_list_2-5>li:before {
	content: "\0025aa  "
}

.lst-kix_list_2-8>li:before {
	content: "\0025aa  "
}

.lst-kix_list_7-1>li:before {
	content: "o  "
}

.lst-kix_list_7-5>li:before {
	content: "\0025aa  "
}

.lst-kix_list_7-2>li:before {
	content: "\0025aa  "
}

.lst-kix_list_7-3>li:before {
	content: "\0025cf  "
}

ul.lst-kix_list_7-5 {
	list-style-type: none
}

ul.lst-kix_list_7-6 {
	list-style-type: none
}

ul.lst-kix_list_7-3 {
	list-style-type: none
}

ul.lst-kix_list_3-7 {
	list-style-type: none
}

ul.lst-kix_list_7-4 {
	list-style-type: none
}

ul.lst-kix_list_3-8 {
	list-style-type: none
}

ul.lst-kix_list_7-7 {
	list-style-type: none
}

ul.lst-kix_list_7-8 {
	list-style-type: none
}

ul.lst-kix_list_3-1 {
	list-style-type: none
}

ul.lst-kix_list_3-2 {
	list-style-type: none
}

.lst-kix_list_7-8>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_3-0 {
	list-style-type: none
}

ul.lst-kix_list_7-1 {
	list-style-type: none
}

ul.lst-kix_list_3-5 {
	list-style-type: none
}

ul.lst-kix_list_7-2 {
	list-style-type: none
}

ul.lst-kix_list_3-6 {
	list-style-type: none
}

ul.lst-kix_list_3-3 {
	list-style-type: none
}

ul.lst-kix_list_7-0 {
	list-style-type: none
}

.lst-kix_list_7-7>li:before {
	content: "o  "
}

ul.lst-kix_list_3-4 {
	list-style-type: none
}

.lst-kix_list_4-0>li:before {
	content: "\0025cf  "
}

.lst-kix_list_4-1>li:before {
	content: "o  "
}

.lst-kix_list_4-4>li:before {
	content: "o  "
}

.lst-kix_list_9-2>li:before {
	content: "\0025aa  "
}

.lst-kix_list_4-3>li:before {
	content: "\0025cf  "
}

.lst-kix_list_4-5>li:before {
	content: "\0025aa  "
}

.lst-kix_list_4-2>li:before {
	content: "\0025aa  "
}

.lst-kix_list_4-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_9-3>li:before {
	content: "\0025cf  "
}

.lst-kix_list_9-0>li:before {
	content: "\0025cf  "
}

.lst-kix_list_9-1>li:before {
	content: "o  "
}

.lst-kix_list_9-7>li:before {
	content: "o  "
}

.lst-kix_list_9-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_9-4>li:before {
	content: "o  "
}

.lst-kix_list_9-5>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_6-6 {
	list-style-type: none
}

ul.lst-kix_list_6-7 {
	list-style-type: none
}

ul.lst-kix_list_6-4 {
	list-style-type: none
}

ul.lst-kix_list_2-8 {
	list-style-type: none
}

ul.lst-kix_list_6-5 {
	list-style-type: none
}

ul.lst-kix_list_6-8 {
	list-style-type: none
}

ul.lst-kix_list_2-2 {
	list-style-type: none
}

.lst-kix_list_1-0>li:before {
	content: "\0025cf  "
}

ul.lst-kix_list_2-3 {
	list-style-type: none
}

ul.lst-kix_list_2-0 {
	list-style-type: none
}

ul.lst-kix_list_2-1 {
	list-style-type: none
}

ul.lst-kix_list_6-2 {
	list-style-type: none
}

.lst-kix_list_9-8>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_2-6 {
	list-style-type: none
}

ul.lst-kix_list_6-3 {
	list-style-type: none
}

.lst-kix_list_1-1>li:before {
	content: "o  "
}

.lst-kix_list_1-2>li:before {
	content: "\0025aa  "
}

ul.lst-kix_list_2-7 {
	list-style-type: none
}

ul.lst-kix_list_6-0 {
	list-style-type: none
}

ul.lst-kix_list_2-4 {
	list-style-type: none
}

ul.lst-kix_list_6-1 {
	list-style-type: none
}

ul.lst-kix_list_2-5 {
	list-style-type: none
}

.lst-kix_list_1-3>li:before {
	content: "\0025cf  "
}

.lst-kix_list_1-4>li:before {
	content: "o  "
}

.lst-kix_list_1-7>li:before {
	content: "o  "
}

.lst-kix_list_1-5>li:before {
	content: "\0025aa  "
}

.lst-kix_list_1-6>li:before {
	content: "\0025cf  "
}

.lst-kix_list_2-0>li:before {
	content: "\0025cf  "
}

.lst-kix_list_2-1>li:before {
	content: "o  "
}

.lst-kix_list_1-8>li:before {
	content: "\0025aa  "
}

.lst-kix_list_2-2>li:before {
	content: "\0025aa  "
}

.lst-kix_list_2-3>li:before {
	content: "\0025cf  "
}

ol {
	margin: 0;
	padding: 0
}

table td,
table th {
	padding: 0
}

.c12 {
	border-right-style: solid;
	padding: 6pt 6pt 6pt 6pt;
	border-bottom-color: #dddddd;
	border-top-width: 1pt;
	border-right-width: 1pt;
	border-left-color: #dddddd;
	vertical-align: bottom;
	border-right-color: #dddddd;
	border-left-width: 1pt;
	border-top-style: solid;
	background-color: #ffffff;
	border-left-style: solid;
	border-bottom-width: 1pt;
	width: 183.2pt;
	border-top-color: #dddddd;
	border-bottom-style: solid
}

.c10 {
	border-right-style: solid;
	padding: 6pt 6pt 6pt 6pt;
	border-bottom-color: #dddddd;
	border-top-width: 1pt;
	border-right-width: 1pt;
	border-left-color: #dddddd;
	vertical-align: bottom;
	border-right-color: #dddddd;
	border-left-width: 1pt;
	border-top-style: solid;
	background-color: #ffffff;
	border-left-style: solid;
	border-bottom-width: 1pt;
	width: 127.6pt;
	border-top-color: #dddddd;
	border-bottom-style: solid
}

.c9 {
	border-right-style: solid;
	padding: 6pt 6pt 6pt 6pt;
	border-bottom-color: #dddddd;
	border-top-width: 1pt;
	border-right-width: 1pt;
	border-left-color: #dddddd;
	vertical-align: bottom;
	border-right-color: #dddddd;
	border-left-width: 1pt;
	border-top-style: solid;
	background-color: #ffffff;
	border-left-style: solid;
	border-bottom-width: 1pt;
	width: 205.5pt;
	border-top-color: #dddddd;
	border-bottom-style: solid
}

.c5 {
	margin-left: 36pt;
	padding-top: 0pt;
	padding-left: 0pt;
	padding-bottom: 0pt;
	line-height: 1.1500000000000001;
	orphans: 2;
	widows: 2;
	text-align: left
}

.c6 {
	color: #000000;
	font-weight: 700;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 11pt;
	font-family: "Calibri";
	font-style: normal
}

.c1 {
	color: #000000;
	font-weight: 400;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 11pt;
	font-family: "Calibri";
	font-style: normal
}

.c3 {
	color: #557176;
	font-weight: 400;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 12pt;
	font-family: "Arial";
	font-style: normal
}

.c21 {
	color: #000000;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 16pt;
	font-family: "Calibri";
	font-style: normal
}

.c0 {
	padding-top: 0pt;
	padding-bottom: 0pt;
	line-height: 1.0;
	orphans: 2;
	widows: 2;
	text-align: left
}

.c7 {
	padding-top: 0pt;
	padding-bottom: 10pt;
	line-height: 1.1500000000000001;
	orphans: 2;
	widows: 2;
	text-align: left
}

.c4 {
	font-size: 12pt;
	font-family: "Arial";
	color: #557176;
	font-weight: 700
}

.c19 {
	text-decoration-skip-ink: none;
	-webkit-text-decoration-skip: none;
	color: #0000ff;
	text-decoration: underline
}

.c16 {
	margin-left: -28.4pt;
	border-spacing: 0;
	border-collapse: collapse;
	margin-right: auto
}

.c15 {
	background-color: #ffffff;	
	
}

.c13 {
	margin-left: 36pt;
	padding-left: 0pt
}

.c20 {
	color: inherit;
	text-decoration: inherit
}

.c14 {
	padding: 0;
	margin: 0
}

.c8 {
	height: 11pt
}

.c2 {
	height: 0pt
}

.c11 {
	font-weight: 700
}

.c18 {
	margin-left: 36pt
}

.c17 {
	background-color: #ffff00
}

.title {
	padding-top: 24pt;
	color: #000000;
	font-weight: 700;
	font-size: 36pt;
	padding-bottom: 6pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

.subtitle {
	padding-top: 18pt;
	color: #666666;
	font-size: 24pt;
	padding-bottom: 4pt;
	font-family: "Georgia";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	font-style: italic;
	orphans: 2;
	widows: 2;
	text-align: left
}

li {
	color: #000000;
	font-size: 11pt;
	font-family: "Calibri"
}

p {
	margin: 0;
	color: #000000;
	font-size: 11pt;
	font-family: "Calibri"
}

h1 {
	padding-top: 24pt;
	color: #000000;
	font-weight: 700;
	font-size: 24pt;
	padding-bottom: 6pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h2 {
	padding-top: 18pt;
	color: #000000;
	font-weight: 700;
	font-size: 18pt;
	padding-bottom: 4pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h3 {
	padding-top: 14pt;
	color: #000000;
	font-weight: 700;
	font-size: 14pt;
	padding-bottom: 4pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h4 {
	padding-top: 12pt;
	color: #000000;
	font-weight: 700;
	font-size: 12pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h5 {
	padding-top: 11pt;
	color: #000000;
	font-weight: 700;
	font-size: 11pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h6 {
	padding-top: 10pt;
	color: #000000;
	font-weight: 700;
	font-size: 10pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

html{
    overflow-y:auto;
}

body{
    font-family: 'Montserrat', sans-serif !important;
}

</style>